import {PriceInfo, Product, User} from '../types/rest'

export const getProductPrice = (product: Product, user: User | null): PriceInfo | undefined => {
  const priceWithIVA = product.prices.find(p => p.withIVA)
  const priceWithoutIVA = product.prices.find(p => !p.withIVA)

  if(!user) return priceWithIVA
  if(!user.isCompany || user.country === 'IT') return priceWithIVA

  return priceWithoutIVA
}
